export const ROUTING_SOURCE = {
  HELP_DESK: 'HELP_DESK',
  INBOX: 'INBOX',
  ROTATE_OWNER: 'ROTATE_OWNER'
};